/* =========================================================
   LA CHARCUTERÍA ARTESANAL — interactions
   ========================================================= */
(function(){
  const clamp = (v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const lerp  = (a,b,t)=>a+(b-a)*t;
  const smooth= t=>t*t*(3-2*t);
  // trapezoid envelope: 0 outside [a,d], ramps a→b up, b→c flat=1, c→d down
  function env(p,a,b,c,d){
    if(p<=a||p>=d) return 0;
    if(p<b) return smooth((p-a)/(b-a));
    if(p<=c) return 1;
    return smooth(1-(p-c)/(d-c));
  }

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- restauración de scroll ----------
     Dejamos que el navegador recupere la posición al volver atrás (default).
     El logo usa un flag de sesión para recargar "desde arriba" SIN desactivar
     esta restauración (antes se ponía en 'manual' y rompía el volver atrás). */
  if('scrollRestoration' in history) history.scrollRestoration = 'auto';
  try{
    if(sessionStorage.getItem('lc_scrollTop')){
      sessionStorage.removeItem('lc_scrollTop');
      window.scrollTo(0, 0);
      requestAnimationFrame(()=>window.scrollTo(0, 0));
    }
  }catch(_){}

  /* ---------- NAV scrolled ---------- */
  const nav = document.querySelector('.nav');
  if(nav){
    const onNav = ()=> nav.classList.toggle('scrolled', window.scrollY>40);
    onNav(); addEventListener('scroll', onNav, {passive:true});
  }

  /* ---------- WhatsApp flotante: visible SOLO mientras se navega el catálogo ---------- */
  const waFab = document.querySelector('.wa-fab');
  if(waFab){
    const fabTrigger = document.getElementById('coleccion');
    if(!fabTrigger){
      // páginas de catálogo (categoría / producto): el botón se muestra siempre
      waFab.classList.add('is-visible');
    } else if('IntersectionObserver' in window){
      // home: visible mientras el catálogo está en pantalla, pero se oculta en
      // cuanto la foto del maestro empieza a aparecer (evita el solape entre secciones)
      const maestro = document.querySelector('.historia .media');
      let catalogVisible = false, maestroVisible = false;
      const syncFab = ()=> waFab.classList.toggle('is-visible', catalogVisible && !maestroVisible);
      new IntersectionObserver((e)=>{ catalogVisible = e[0].isIntersecting; syncFab(); }, { threshold: 0 }).observe(fabTrigger);
      if(maestro){
        new IntersectionObserver((e)=>{ maestroVisible = e[0].isIntersecting; syncFab(); }, { threshold: 0 }).observe(maestro);
      }
      syncFab();
    } else {
      waFab.classList.add('is-visible');
    }
  }

  /* ---------- HERO scrollytelling ---------- */
  const scrollSec = document.querySelector('.hero-scroll');
  const rotor   = document.getElementById('hamRotor');
  const video   = document.getElementById('hamVideo');
  const gloss   = document.getElementById('hamGloss');
  const panelTitle = document.querySelector('.panel-title');
  const capTitle= document.getElementById('capTitle');
  const cap1    = document.getElementById('cap1');
  const cap2    = document.getElementById('cap2');
  const cue     = document.querySelector('.scroll-cue');

  let progress = 0, target = 0, suppressHero = false;

  function measure(){
    const rect = scrollSec.getBoundingClientRect();
    const total = scrollSec.offsetHeight - window.innerHeight;
    target = clamp(-rect.top / total);
  }

  // batch currentTime writes into one per animation frame — avoids
  // redundant decode work when the scroll handler fires faster than paint
  let videoTargetTime = 0, videoSeekQueued = false;
  function scheduleVideoSeek(){
    if(videoSeekQueued || !video || !isFinite(video.duration) || video.duration <= 0) return;
    videoSeekQueued = true;
    requestAnimationFrame(()=>{
      videoSeekQueued = false;
      // clamp short of duration: setting currentTime === duration can fire
      // `ended`, pausing the decoder and flickering the last frame to black
      const safeMax = Math.max(0, video.duration - 0.0001);
      video.currentTime = Math.min(videoTargetTime, safeMax);
    });
  }

  function applyHero(p){
    // durante una navegación por anclas del home congelamos el hero:
    // así el deslizamiento no reproduce la animación del jamón en cámara rápida
    if(suppressHero) return;

    const rise = lerp(8, -10, p);            // subtle vertical drift
    rotor.style.transform = `translateY(${rise}px)`;

    // scrub the jamón video frame-by-frame as the user scrolls
    if(video && isFinite(video.duration) && video.duration > 0){
      videoTargetTime = p * video.duration;
      scheduleVideoSeek();
    }

    // travelling specular sweep
    if(gloss) gloss.style.transform = `translateX(${lerp(-70,70,p)}%)`;

    // text panels handoff
    panelTitle.style.opacity = env(p, -1, -1, 0.06, 0.16);
    panelTitle.style.transform = `translateY(${lerp(0,-40,clamp(p/0.18))}px)`;

    // "El arte de curar" entra primero…
    if(capTitle) capTitle.style.opacity = env(p, 0.17, 0.25, 0.43, 0.51);
    // …y solo cuando ya está, emerge el primer texto desde la izquierda
    setCap(cap1, env(p, 0.27, 0.35, 0.43, 0.51), p, 'left');
    setCap(cap2, env(p, 0.56, 0.66, 0.80, 0.88), p, 'right');

    if(cue) cue.style.opacity = clamp(1 - p*8);
  }

  function setCap(el, o, p, side){
    if(!el) return;
    el.style.opacity = o;
    const dx = side==='left' ? lerp(-30,0,smooth(clamp(o))) : lerp(30,0,smooth(clamp(o)));
    el.style.transform = `translateX(${dx}px)`;
  }

  function tick(){
    progress += (target - progress) * 0.12;
    if(Math.abs(target-progress)<0.0004) progress = target;
    applyHero(progress);
    requestAnimationFrame(tick);
  }

  function init(){
    if(!scrollSec) return;
    measure();
    addEventListener('scroll', measure, {passive:true});
    addEventListener('resize', ()=>{ measure(); }, {passive:true});

    if(video){
      if(reduce){
        // respect prefers-reduced-motion: freeze on the first frame, no scrubbing
        video.removeAttribute('src'); video.load();
      } else {
        if(video.readyState < 1){
          // some mobile browsers delay `loadedmetadata` until an explicit load()
          try{ video.load(); }catch(e){}
        }
        // Prime the decoder up front. On mobile (iOS Safari especially),
        // seeking an MP4 whose decode pipeline has never run leaves the frame
        // "stuck" on the first scroll-down until the user scrolls back up and
        // down again. A muted play()->pause() (allowed because the video is
        // muted + playsinline) warms the decoder so the very first seek is smooth.
        const warmDecoder = function(){
          try{
            var pr = video.play();
            if(pr && pr.then){ pr.then(function(){ video.pause(); video.currentTime = 0; }).catch(function(){}); }
            else { video.pause(); video.currentTime = 0; }
          }catch(e){}
        };
        if(video.readyState >= 2){ warmDecoder(); }
        else { video.addEventListener('loadeddata', warmDecoder, {once:true}); }
      }
    }

    if(reduce){ applyHero(0.0); progress=target=0; return; }
    requestAnimationFrame(tick);
  }
  init();

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  }, {threshold:0, rootMargin:'0px 0px -10% 0px'});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  /* ---------- sello de garantía: decode anticipado ----------
     Decodifica el sello apenas carga la página para que, al llegar a la sección
     de garantía, ya esté listo y no parpadee el recuadro de su sombra. Es seguro:
     solo fuerza el decode; si falla no oculta ni altera nada. */
  const sealImg = document.querySelector('.wax-seal');
  if(sealImg && sealImg.decode){ sealImg.decode().catch(()=>{}); }

  /* ---------- nav burger (mobile) ---------- */
  const burger = document.querySelector('.nav-burger');
  const navLinks = document.querySelector('.nav-links');
  if(burger && navLinks){
    const closeMenu = ()=>{
      navLinks.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    };
    burger.addEventListener('click', ()=>{
      const open = navLinks.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
    // cierra el menú al elegir un enlace (móvil) para no tapar la navegación
    navLinks.querySelectorAll('a').forEach(a=> a.addEventListener('click', closeMenu));
    // cierra también al hacer clic fuera del menú
    document.addEventListener('click', (e)=>{
      if(navLinks.classList.contains('open') && !navLinks.contains(e.target) && !burger.contains(e.target)) closeMenu();
    });
  }

  /* ---------- logo "La Charcutería": vuelve al inicio como carga nueva ---------- */
  const brandLink = document.querySelector('.nav .brand');
  if(brandLink){
    brandLink.addEventListener('click', (e)=>{
      const path = window.location.pathname;
      const atHome = path === '/' || path === '/index.html' || path === '';
      if(atHome){
        // ya estamos en el home: recargamos desde arriba para reproducir la intro del hero
        e.preventDefault();
        try{ sessionStorage.setItem('lc_scrollTop', '1'); }catch(_){}  // forzar arriba tras la recarga
        window.history.replaceState(null, '', '/');   // limpia el #hash para no saltar a una sección
        window.scrollTo(0, 0);
        window.location.reload();
      }
      // si estamos en otra página (producto, catálogo…), el href="/" ya carga el home fresco
    });
  }

  /* ---------- category carousel ---------- */
  document.querySelectorAll('.cat-carousel').forEach(carousel=>{
    const track = carousel.querySelector('.cat-grid');
    const prev  = carousel.querySelector('.cat-arrow.prev');
    const next  = carousel.querySelector('.cat-arrow.next');
    if(!track) return;

    const step = (dir)=>{
      const card = track.querySelector('.cat-card, .pcard');
      if(!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left:(card.getBoundingClientRect().width+gap)*dir, behavior:'smooth' });
    };
    prev?.addEventListener('click', ()=>step(-1));
    next?.addEventListener('click', ()=>step(1));

    const updateArrows = ()=>{
      const max = track.scrollWidth - track.clientWidth;
      if(prev) prev.disabled = track.scrollLeft <= 4;
      if(next) next.disabled = track.scrollLeft >= max-4;
    };
    track.addEventListener('scroll', updateArrows, {passive:true});
    addEventListener('resize', updateArrows, {passive:true});
    updateArrows();
  });

  /* ---------- in-page anchors: smooth only on intentional clicks ----------
     (global scroll-behavior is off so back/forward restoration stays instant
      and never animates up-and-down through the tall hero) */
  let navSettle = null;
  function suppressHeroDuringScroll(){
    suppressHero = true;
    const onScroll = ()=>{
      clearTimeout(navSettle);
      navSettle = setTimeout(()=>{
        suppressHero = false;
        removeEventListener('scroll', onScroll);
      }, 140);
    };
    addEventListener('scroll', onScroll, {passive:true});
    // red de seguridad: reanuda el hero aunque el scroll no llegue a moverse
    setTimeout(()=>{ if(suppressHero){ suppressHero = false; removeEventListener('scroll', onScroll); } }, 2200);
  }

  document.addEventListener('click', (e)=>{
    if(e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const a = e.target.closest('a[href]');
    if(!a) return;
    const url = new URL(a.href, location.href);
    if(url.pathname !== location.pathname || url.search !== location.search) return;
    if(url.hash.length <= 1) return;
    const target = document.querySelector(url.hash);
    if(!target) return;
    e.preventDefault();
    if(scrollSec) suppressHeroDuringScroll();
    target.scrollIntoView({ behavior:'smooth', block:'start' });
    history.pushState(null, '', url.hash);
  });

  /* ---------- "Volver" → restaura scroll exacto SOLO si venimos del home ----------
     Si se llegó desde otra página interna (p. ej. un producto), seguimos el href
     normal: así, al volver desde una categoría no rebotamos hacia atrás a un
     producto en vez de llegar al catálogo / sección de inicio. */
  document.querySelectorAll('[data-back]').forEach(backLink=>{
    backLink.addEventListener('click', (e)=>{
      let ref = null;
      try{ ref = document.referrer ? new URL(document.referrer) : null; }catch(_){}
      const fromHome = ref && ref.origin === location.origin
        && (ref.pathname === '/' || ref.pathname === '');
      if(history.length > 1 && fromHome){
        e.preventDefault();
        history.back();
      }
      // si no venimos del home, dejamos que el href navegue normalmente
    });
  });

  /* ---------- pcard CTA: navigate when no Shopify variantId yet ---------- */
  document.querySelectorAll('.pcard-cta__btn').forEach(btn=>{
    btn.addEventListener('click', (e)=>{
      const variantId = btn.getAttribute('data-variant-id');
      if(!variantId){
        e.preventDefault();
        e.stopPropagation();
        const link = btn.closest('.pcard')?.querySelector('.pcard-link');
        if(link) window.location.href = link.href;
      }
      // With variantId: cart.js handles the add flow
    });
  });

  /* ---------- pcard touch: un solo toque abre el producto ----------
     En táctil el botón "Agregar" se muestra siempre vía CSS (@media hover:none),
     así que el enlace de la tarjeta navega al primer toque (sin doble toque). */

  /* ---------- buscador de productos ---------- */
  (function(){
    const toggle  = document.getElementById('searchToggle');
    const panel   = document.getElementById('navSearch');
    const input   = document.getElementById('searchInput');
    const results = document.getElementById('searchResults');
    const closeBtn= document.getElementById('searchClose');
    const dataEl  = document.getElementById('searchData');
    if(!toggle || !panel || !input || !results || !dataEl) return;

    let items = [];
    try{ items = JSON.parse(dataEl.textContent || '[]'); }catch(_){ items = []; }

    // normaliza: minúsculas y sin acentos, para una búsqueda flexible
    const norm = (s)=> (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    const haystacks = items.map(p => norm(p.name + ' ' + p.cat + ' ' + p.format));

    let activeIndex = -1;
    let shown = [];

    function render(q){
      const query = norm(q).trim();
      if(!query){ results.innerHTML = ''; shown = []; activeIndex = -1; return; }
      const terms = query.split(/\s+/);
      shown = items.filter((_, i)=> terms.every(t => haystacks[i].includes(t))).slice(0, 8);
      activeIndex = -1;

      if(!shown.length){
        results.innerHTML = '<p class="search-empty">Sin resultados para «'
          + q.replace(/</g,'&lt;') + '»</p>';
        return;
      }
      results.innerHTML = shown.map((p, i)=>{
        const sub = p.format ? (p.cat + ' · ' + p.format) : p.cat;
        return '<a class="search-result" role="option" data-i="'+i+'" href="/products/'+p.slug+'">'
          + '<span class="search-result__main">'
          + '<span class="search-result__name">'+p.name+'</span>'
          + '<span class="search-result__cat">'+sub+'</span>'
          + '</span>'
          + (p.price ? '<span class="search-result__price">'+p.price+'</span>' : '')
          + '</a>';
      }).join('');
    }

    function setActive(i){
      const nodes = results.querySelectorAll('.search-result');
      if(!nodes.length) return;
      activeIndex = (i + nodes.length) % nodes.length;
      nodes.forEach((n, k)=> n.classList.toggle('active', k === activeIndex));
      nodes[activeIndex].scrollIntoView({ block:'nearest' });
    }

    function open(){
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(()=> input.focus(), 60);
    }
    function close(){
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }
    const isOpen = ()=> panel.classList.contains('open');

    toggle.addEventListener('click', ()=> isOpen() ? close() : open());
    closeBtn?.addEventListener('click', ()=>{ close(); toggle.focus(); });

    input.addEventListener('input', ()=> render(input.value));

    input.addEventListener('keydown', (e)=>{
      if(e.key === 'ArrowDown'){ e.preventDefault(); setActive(activeIndex + 1); }
      else if(e.key === 'ArrowUp'){ e.preventDefault(); setActive(activeIndex - 1); }
      else if(e.key === 'Enter'){
        const nodes = results.querySelectorAll('.search-result');
        const target = activeIndex >= 0 ? nodes[activeIndex] : nodes[0];
        if(target){ e.preventDefault(); window.location.href = target.href; }
      } else if(e.key === 'Escape'){ close(); toggle.focus(); }
    });

    // cierra al hacer clic fuera del buscador
    document.addEventListener('click', (e)=>{
      if(isOpen() && !panel.contains(e.target) && !toggle.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e)=>{
      if(e.key === 'Escape' && isOpen()) close();
    });
  })();

  /* ---------- formulario HORECA: solicitar catálogo por mayor ---------- */
  (function(){
    const openBtn = document.getElementById('horecaFormOpen');
    const modal   = document.getElementById('horecaModal');
    const form    = document.getElementById('horecaForm');
    const errBox  = document.getElementById('horecaFormErr');
    if(!openBtn || !modal || !form) return;

    // === CONFIGURACIÓN ===
    const WA_NUMBER = '56944058741';                 // WhatsApp destino (+56 9 4405 8741)
    const WEB3FORMS_KEY = 'WEB3FORMS_ACCESS_KEY';    // ← pega aquí tu access key de web3forms.com para activar la copia por correo

    let lastFocus = null;

    function openModal(){
      lastFocus = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(()=>{ form.querySelector('input')?.focus(); }, 80);
    }
    function closeModal(){
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
    const isModalOpen = ()=> modal.classList.contains('open');

    openBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-hmclose]').forEach(el=> el.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape' && isModalOpen()) closeModal(); });

    const emailOk = (v)=> /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    // --- validación de RUT chileno (formato + dígito verificador, módulo 11) ---
    const cleanRut = (v)=> v.replace(/[.\-\s]/g, '').toUpperCase();
    function rutOk(v){
      const r = cleanRut(v);
      if(!/^\d{6,9}[0-9K]$/.test(r)) return false;
      const body = r.slice(0, -1);
      const dv   = r.slice(-1);
      let sum = 0, mul = 2;
      for(let i = body.length - 1; i >= 0; i--){
        sum += parseInt(body[i], 10) * mul;
        mul = mul === 7 ? 2 : mul + 1;
      }
      const res = 11 - (sum % 11);
      const dvCalc = res === 11 ? '0' : res === 10 ? 'K' : String(res);
      return dvCalc === dv;
    }
    function formatRut(v){
      const r = cleanRut(v);
      if(r.length < 2) return v;
      const body = r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return body + '-' + r.slice(-1);
    }
    // formatea el RUT al salir del campo (si es válido en estructura)
    const rutInput = form.elements['rut'];
    if(rutInput){
      rutInput.addEventListener('blur', ()=>{
        const v = rutInput.value.trim();
        if(v && /^\d{6,9}[0-9kK]$/.test(cleanRut(v))) rutInput.value = formatRut(v);
      });
    }

    function showError(msg, field){
      if(errBox){ errBox.textContent = msg; errBox.hidden = false; }
      form.querySelectorAll('input').forEach(i=> i.classList.remove('invalid'));
      if(field) field.classList.add('invalid');
      field?.focus();
    }

    form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const empresa   = form.elements['empresa'].value.trim();
      const rut       = form.elements['rut'].value.trim();
      const direccion = form.elements['direccion'].value.trim();
      const correo    = form.elements['correo'].value.trim();

      if(!rut)                 return showError('Falta el RUT de la empresa.', form.elements['rut']);
      if(!rutOk(rut))          return showError('El RUT no es válido. Revisa el número y el dígito verificador.', form.elements['rut']);
      if(!empresa)             return showError('Indícanos el nombre de tu empresa.', form.elements['empresa']);
      if(!direccion)           return showError('Falta la dirección.', form.elements['direccion']);
      if(!correo || !emailOk(correo)) return showError('Ingresa un correo válido.', form.elements['correo']);

      if(errBox) errBox.hidden = true;
      const rutFmt = formatRut(rut);

      // 1) copia por correo (Web3Forms) — solo si hay access key configurada
      if(WEB3FORMS_KEY && WEB3FORMS_KEY !== 'WEB3FORMS_ACCESS_KEY'){
        try{
          fetch('https://api.web3forms.com/submit', {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            keepalive:true,
            body: JSON.stringify({
              access_key: WEB3FORMS_KEY,
              subject: 'Nueva solicitud de catálogo HORECA',
              from_name: empresa,
              'RUT': rutFmt,
              'Empresa': empresa,
              'Dirección': direccion,
              'Correo': correo,
            }),
          }).catch(()=>{});
        }catch(_){}
      }

      // 2) abre WhatsApp con la solicitud lista para enviar
      const msg =
        'Hola, quiero solicitar el catálogo por mayor (HORECA).\n\n' +
        '🧾 RUT: ' + rutFmt + '\n' +
        '🏢 Empresa: ' + empresa + '\n' +
        '📍 Dirección: ' + direccion + '\n' +
        '✉️ Correo: ' + correo;
      const waUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
      window.open(waUrl, '_blank', 'noopener');

      form.reset();
      closeModal();
    });
  })();
})();
